import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {httpService} from './services/http'
import { systemSrv } from './services/system'

import Default from "./layouts/Default.vue";
import NoSidebar from "./layouts/NoSidebar.vue";

Vue.component("default-layout", Default);
Vue.component("no-sidebar-layout", NoSidebar);

let config = require(`./config.production.json`)

Vue.config.productionTip = false;

import VueSnackbar from 'vue-snack' 
Vue.use(VueSnackbar, {})

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// External function in module
let vueCreatedB = false

async function initializeApp() {
  if(!vueCreatedB){
    vueCreatedB = true
    store.commit('setConfig', config)
    console.log("Initialising tokens, profiles, and other necessary system components before proceeding to mount the app")
    await systemSrv.initUser()
  }
}

initializeApp().then(_ => {
  new Vue({
    router,
    store,
    data: {
      brand: {}
    },
    async created() {
      this.$mount('#app')
      console.log("System Initialised. App mounted!")
    },
    render: (h) => h(App),
  }).$mount('#app');

})
